import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

import { Subscription, SubscriptionDetail } from '@model/SubscriptionTypes'

import { useFormatNumber } from '@hooks/useFormatNumber'

export interface SubscriptionDetailModalProps {
  subscription: Subscription
  selectedSubscriptionDetail?: SubscriptionDetail
  isSelectEnabled?: boolean
  onConfirm(subscriptionDetail?: SubscriptionDetail): void
  onCancel?(): void
}

export const SubscriptionDetailModal: BaseModalType<SubscriptionDetailModalProps> = ({
  close,
  subscription,
  selectedSubscriptionDetail,
  isSelectEnabled = true,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation()
  const { formatMoney } = useFormatNumber()

  const [current, setCurrent] = useState<SubscriptionDetail | undefined>(selectedSubscriptionDetail)

  const options = subscription.details.map((detail) => ({
    label: `${detail.name} - ${formatMoney(detail.amount)}/${t('Market Data.month')}`,
    value: detail.id.toString(),
    disabled: !isSelectEnabled && detail.id !== selectedSubscriptionDetail?.id,
    caption: detail.description,
  }))

  const handleChange = (id: string) => {
    if (!isSelectEnabled) return
    const selected = subscription.details.find((d) => d.id.toString() === id)
    if (selected) setCurrent(selected)
  }

  const handleCancel = () => {
    onCancel?.()
    close()
  }

  const handleConfirm = () => {
    onConfirm(current)
    close()
  }

  return (
    <Modal>
      <Modal.Header>{t('Market Data.Choose Level')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Input.Radio
          name='subscription-detail'
          value={current?.id?.toString() ?? ''}
          options={options}
          onChange={handleChange}
        />
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={handleCancel}>{t('Cancel')}</Modal.Footer.Secondary>
        <Modal.Footer.Primary onClick={handleConfirm}>{t('Confirm')}</Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
